import NavBar from "../components/navbar";
import "../css/main.css";
import "../css/aboutme.css";
import AboutMe from "../components/aboutme";
import Home from "../components/home";
import Education from "./education";
import Experience from "./experience";
import Projects from "./projects";
import SectionTitle from "../components/sectionTitle";

const MainPage = () => {
    return (
        <div className="main-page-container">
            <NavBar />
            <div className="main-page-content">
                <Home />
                <SectionTitle title_text="About Me" id="about" />
                <AboutMe />
                <SectionTitle title_text="Education" id="education" />
                <Education />
                <SectionTitle title_text="Experience" id="experience" />
                <Experience />
                <SectionTitle title_text="Projects" id="projects" />
                <Projects />
            </div>
        </div>
    );
};

export default MainPage;
